import { ReactNode } from 'react';
import loginBg from '../../assets/login.png';

interface AuthCardProps {
  title: string;
  subtitle?: string;
  children: ReactNode;
}

export function AuthCard({ title, subtitle, children }: AuthCardProps) {
  return (
    <div
      className="relative w-full min-h-screen flex items-center justify-end max-[991px]:justify-center bg-cover bg-center bg-no-repeat"
      style={{ backgroundImage: `url(${loginBg})` }}
    >
      {/* Overlay */}
      <div className="absolute inset-0 bg-black/40 dark:bg-black/60 transition-colors duration-300" />

      {/* Card */}
      <div className="relative z-10 w-full max-w-[520px] mr-[5%] px-4 max-[991px]:mr-0 max-[991px]:mx-auto max-[991px]:px-4 max-[991px]:py-8">
        <div className="overflow-hidden rounded-2xl shadow-[0_20px_60px_rgba(0,0,0,0.35)] backdrop-blur-sm bg-white/95 dark:bg-slate-900/95 transition-colors duration-300">

          {/* Brand accent bar */}
          <div className="h-1 bg-gradient-to-r from-red-600 to-red-400" />

          <div className="px-9 py-8 max-[480px]:px-5 max-[480px]:py-6">

            <h2 className="text-2xl font-extrabold text-center text-slate-800 dark:text-white tracking-tight">
              {title}
            </h2>

            {subtitle && (
              <p className="mt-1 text-sm text-center text-slate-500 dark:text-slate-400">
                {subtitle}
              </p>
            )}

            <div className="mt-6">
              {children}
            </div>

          </div>
        </div>
      </div>
    </div>
  );
}
